import React from "react";

class IconPhone extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.width}
        height={this.props.height}
        fill="none"
        viewBox="0 0 24 25"
      >
        <path
          fill="#fff"
          d="M19.202 14.375c-.43-.455-1.038-.671-1.733-.623-.662.048-1.247.36-1.821.983l-1.226 1.343c-.96-.527-1.854-1.259-2.87-2.326-1.224-1.296-2.03-2.411-2.604-3.61l.243-.264c.441-.468.905-.96 1.324-1.488.84-1.043.817-2.542-.044-3.538a80.088 80.088 0 00-2.947-3.238C6.431.487 5.096.463 3.96 1.542c-.475.456-.927.971-1.369 1.451l-.474.54C1.343 4.373.979 5.452 1 6.795c.022 1.068.232 2.16.684 3.466.927 2.687 2.429 5.206 4.559 7.713a22.837 22.837 0 005.54 4.713c1.292.78 2.86 1.62 4.658 1.943.343.06.75.12 1.181.12.475 0 .994-.072 1.512-.276.795-.324 1.37-.923 1.777-1.403.21-.24.42-.48.64-.72.288-.312.564-.623.829-.947.827-1.044.827-2.615-.012-3.586-1.07-1.2-2.152-2.363-3.167-3.443zM5.714 3.077c.143 0 .298.108.486.312l2.494 2.71.144.157c.264.335.21.515 0 .743a40.3 40.3 0 01-1.336 1.463l-.254.276c-.596.624-.706 1.224-.364 2.051.452 1.08 1.104 2.147 2.064 3.335 1.17 1.45 2.362 2.578 3.631 3.466.364.252.773.503 1.325.791.574.312 1.17.192 1.655-.335l1.546-1.668c.099-.108.187-.192.276-.252.165-.108.309-.108.474.024.055.048.1.096.155.144.86.924 1.71 1.86 2.571 2.795.287.312.32.444.287.588-.044.168-.143.36-.276.503-.364.432-.74.84-1.125 1.26l-.387.431c-.441.492-.993.684-1.744.612-1.655-.168-3.145-.947-4.492-1.75-2.207-1.32-4.172-3.095-5.839-5.278-1.534-1.991-2.605-3.922-3.3-5.913-.353-1.02-.585-1.883-.585-2.89v-.037c-.033-.611.199-1.199.673-1.69.31-.325.607-.648.917-.984l.518-.552c.199-.216.342-.312.486-.312z"
        ></path>
      </svg>
    );
  }
}

IconPhone.defaultProps = {
    width: 24,
    height: 25
}

export default IconPhone;
